/*
This file is located in the main branch
Last time the file was updated (UTC): [08.08.2024 13:41:36]
Permissions to update outside the main branch: [true]
*/

import axios from 'axios/axios.paylater-api';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend, { BackendOptions, RequestCallback } from 'i18next-http-backend';
import BackendAdapter from 'i18next-multiload-backend-adapter';
import { Dictionary } from 'lodash';
import { initReactI18next } from 'react-i18next';

let translations: Dictionary<Dictionary<Dictionary<string>>> | null = null;

export const loadTranslations = async () => {
    const { data } = await axios.get<Dictionary<Dictionary<Dictionary<string>>>>('/localization');

    return data;
};

export const clearTranslations = () => {
    translations = null;
};

const loadResources = async (lang: string[]) => {
    if (!translations) translations = await loadTranslations();

    return JSON.stringify(
        Object.entries(translations).reduce<any>((res, [key, value]) => {
            if (lang.includes(key)) res[key] = value;
            return res;
        }, {})
    );
};

export const getCultureVariant = (lang: string) => {
    switch (lang) {
        case 'ru':
            return 'rus';
        case 'uz':
            return 'uzb';
        default:
            return lang;
    }
};

const backendOptions = {
    loadPath: '{{lng}}',
    allowMultiLoading: true,

    request: (
        options: BackendOptions,
        url: string,
        payload: unknown | string,
        callback: RequestCallback
    ) => {
        try {
            const lng = url.split('+');
            loadResources(lng).then((response) => {
                callback(null, {
                    data: response,
                    status: 200,
                });
            });
        } catch (e) {
            console.error(e);
            callback(null, {
                status: 500,
                data: '',
            });
        }
    },
};

if (localStorage.getItem('i18nextLng') === null) {
    localStorage.setItem('i18nextLng', 'uz');
}

const adapter = new BackendAdapter(undefined, {
    backend: Backend,
    backendOption: backendOptions,
});

i18n.use(LanguageDetector)
    .use(adapter)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        supportedLngs: ['uz', 'en', 'ru'],
        detection: {
            order: ['cookie', 'localStorage', 'htmlTag', 'path', 'subdomain'],
            caches: ['cookie'],
        },
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
